/**
 * Surfaced on VideoStreamingStatus.reason (and logs). Not terminal Electron
 * fallbacks — keep these off WebCodecsFallbackReason so the host can restart.
 */
export type NativeVideoRejectReason =
  | 'camera-not-allowed'
  | 'codec-not-allowed'
  | 'ipc-unauthorized'
  | 'ipc-payload-invalid'
  | 'ipc-send-failed'
  | 'camera-unavailable';

export const NATIVE_VIDEO_REJECT_REASONS: readonly NativeVideoRejectReason[] = Object.freeze([
  'camera-not-allowed',
  'codec-not-allowed',
  'ipc-unauthorized',
  'ipc-payload-invalid',
  'ipc-send-failed',
  'camera-unavailable',
]);

const REASONS = new Set<string>(NATIVE_VIDEO_REJECT_REASONS);

export function nativeVideoRejectReason(raw: string | undefined): NativeVideoRejectReason | undefined {
  if (!raw) return undefined;
  const trimmed = raw.trim();
  if (REASONS.has(trimmed)) return trimmed as NativeVideoRejectReason;
  const match = NATIVE_VIDEO_REJECT_REASONS.find((reason) => trimmed.includes(reason));
  return match;
}
